import { render, staticRenderFns } from "./propertiesSelector.vue?vue&type=template&id=7c23dacc&scoped=true"
import script from "./propertiesSelector.vue?vue&type=script&lang=js"
export * from "./propertiesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c23dacc",
  null
  
)

export default component.exports